<template>
  <div>
    <div class="item">
      <div class="sub-title">
        {{ "주소" }}
        <span class="keyColor">{{ $t("Verification.common.required") }}</span>
      </div>
      <div class="authID input-box">
        <div flex>
          <div class="one-fifth">
            <el-input v-model="searchdata.addr1" disabled class="addr1" />
          </div>
          <button @click="sample6_execDaumPostcode" class="search-address">
            {{ "주소검색" }}
          </button>
        </div>
        <div class="detail full-box mt8">
          <el-input v-model="searchdata.addr2" disabled class="addr2" />
        </div>
        <div>
          <el-input
            type="text"
            maxlength="30"
            v-model="searchdata.addr3"
            placeholder="상세주소 입력"
            class="en-name mt8"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    searchdata: {
      addr1: String,
      addr2: String,
      addr3: String,
    },
    // showaddress: Boolean,
  },
  data() {
    return {};
  },
  methods: {
    syncing(a, b) {
      this.searchdata.addr1 = a;
      this.searchdata.addr2 = b;
    },
    sample6_execDaumPostcode() {
      const syncing = this.syncing;
      let sample6_postcode = this.searchdata.addr1;
      let sample6_address = this.searchdata.addr2;

      new window.daum.Postcode({
        oncomplete: (data) => {
          // 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

          // 각 주소의 노출 규칙에 따라 주소를 조합한다.
          // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
          let addr = ""; // 주소 변수
          let extraAddr = ""; // 참고항목 변수

          //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
          if (data.userSelectedType === "R") {
            // 사용자가 도로명 주소를 선택했을 경우
            addr = data.roadAddress;
          } else {
            // 사용자가 지번 주소를 선택했을 경우(J)
            addr = data.roadAddress;
          }
          // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
          if (data.userSelectedType === "R") {
            // 법정동명이 있을 경우 추가한다. (법정리는 제외)
            // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
            if (data.bname !== "" && /[동|로|가]$/g.test(data.bname)) {
              extraAddr += data.bname;
            }
            // 건물명이 있고, 공동주택일 경우 추가한다.
            if (data.buildingName !== "" && data.apartment === "Y") {
              extraAddr +=
                extraAddr !== "" ? ", " + data.buildingName : data.buildingName;
            }
            // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
            if (extraAddr !== "") {
              extraAddr = " (" + extraAddr + ")";
            }
            // 조합된 참고항목을 해당 필드에 넣는다.
            this.sample6_extraAddress = extraAddr;
          } else {
            this.sample6_extraAddress = "";
          }

          // 우편번호와 주소 정보를 해당 필드에 넣는다.
          sample6_postcode = data.zonecode;
          sample6_address = addr;
          syncing(data.zonecode, addr);
          // 커서를 상세주소 필드로 이동한다.
          // this.sample6_detailAddress.focus();
        },
      }).open();
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  .item {
    margin-top: 12px;
    .sub-title {
      margin-bottom: 8px;
      font-size: 12px;
      font-weight: normal;
      line-height: 1.5;
      color: #333;
    }
    .authID {
      .search-address {
        width: 62px;
        padding: 10px 0px 11px;
        font-size: 12px;
        color: #333;
        border: 1px solid #dcdfe3;
        border-radius: 0 2px 2px 0;
        background-color: #fff;
      }
      .one-fifth {
        width: calc(100% - 62px);
        // border: 1px solid #dcdfe3;
        // border-right: 0 solid;
        // border-right:0;
        // border-radius: 2px 0 0 2px;
      }
    }
    .detail {
      // padding: 11px 0 11px 8px;
      // border-radius: 2px;
      // border: solid 1px #dcdfe3;
      // background-color: #f7f8fa;
      &.full-box {
        height: 38px;
        color: #333;
        background-color: #fff;
      }
      &.dropdown {
        position: relative;
        color: #afafaf;
        background-color: #fff;
        &:after {
          content: "";
          position: absolute;
          top: 13px;
          right: 9px;
          width: 6.7px;
          height: 12px;
          background-image: url("../../../../../../assets/img/mypage/button_arrow_right_icon.svg");
          background-size: 6.7px 12px;
          background-repeat: no-repeat;
        }
        &.selected {
          color: #333;
          border: solid 1px #00b473;
          background-color: #f2fbf8;
        }
        &.change {
          color: #333;
          border: solid 1px #00b473;
          background-color: #f2fbf8;
        }
      }
    }
    .input-box {
      .en-name.half {
        width: calc((100% - 12px) / 2);
      }
    }
  }
}
</style>
